import {invalidatePartialInterest} from 'resources/mandark.resource';

interface InvalidatableQuery {
  done: () => Record<string, unknown>;
}

/**
 * Re-dirties each query's cached interest for a silent background refetch, without flipping any
 * consumer's `isReady` flag. An exact-match invalidation (`query.done()`) alone can miss the cache
 * key a passively-read resource's next `getResource()` call actually checks (e.g. a classroom's
 * student/invitation counts, or a list server-paged on its own sort/search params) — invalidating
 * by the query's bare `resourcePath` too catches those as well.
 */
export function softInvalidateQueries(queries: InvalidatableQuery[]) {
  queries.forEach((query) => {
    const doneQuery = query.done();
    invalidatePartialInterest(doneQuery);
    invalidatePartialInterest({resourcePath: doneQuery.resourcePath});
  });
}
